<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="banner-box" id="home" ref="home">
      <div class="banner-text">
        <div class="title">Unlimited Creativity, Leading Technology</div>
        <div class="text">
          We specialize in advertising promotion, intelligent consulting,
          authoritative information, and cutting-edge technological services.
          Let us bring comprehensive growth to your business!
        </div>
      </div>
    </div>
    <div class="banner-list">
      <div class="img-list">
        <div class="item">
          <img src="../assets/business-1.png" alt="" />
          <p>Vision</p>
        </div>
        <div class="item">
          <img src="../assets/business-2.png" alt="" />
          <p>Strategy</p>
        </div>
        <div class="item">
          <img src="../assets/business-3.png" alt="" />
          <p>Vision</p>
        </div>
        <div class="item">
          <img src="../assets/business-4.png" alt="" />
          <p>Strategy</p>
        </div>
      </div>
      <div class="content">
        <div class="title">
          The innovative force leading brands to global markets
        </div>
        <div class="text">
          VISTA TECH is dedicated to providing you with innovative advertising
          planning, brand promotion, and digital marketing solutions. Our
          professional team will assist your brand in shining brightly in
          Singapore and global markets. <br />
          Through personalized and efficient advertising strategies, we help you
          achieve business growth, improve sales performance, and establish an
          outstanding brand image.
        </div>
      </div>
    </div>
    <div class="wealth-box">
      <div class="wealth-title">
        Personalized market strategies
      </div>
      <div class="wealth-text">
        We have successfully assisted numerous enterprises in enhancing their
        overall competitiveness and resilience through exquisite advertising
        strategies, enabling their brands to possess the potential for
        continuous development and inheritance.
      </div>
      <div class="list">
        <div class="item">
          <img src="../assets/wealth-1.png" alt="" />
          <p>Product strategy</p>
        </div>
        <div class="item">
          <img src="../assets/wealth-2.png" alt="" />
          <p>Promotion strategy</p>
        </div>
        <div class="item">
          <img src="../assets/wealth-3.png" alt="" />
          <p>Advertising strategy</p>
        </div>
      </div>
    </div>
    <div class="mission-box">
      <div class="title">
        Insightful data, Market mastery, Surpassing competition
      </div>
      <div class="list">
        <div class="item">
          <img src="../assets/mission-1.png" alt="" />
          <h4>
            Data monitoring and analysis
          </h4>
          <p>
            By tracking and analyzing various key indicators, we help you
            understand market trends, customer behavior, and product
            performance.
          </p>
        </div>
        <div class="item">
          <img src="../assets/mission-2.png" alt="" />
          <h4>
            Market change analysis
          </h4>
          <p>
            Through in-depth market research and analysis, we provide valuable
            insights into market trends, consumer preferences, and competitive
            situations.
          </p>
        </div>
        <div class="item">
          <img src="../assets/mission-3.png" alt="" />
          <h4>
            Competitor analysis
          </h4>
          <p>
            Our competitor analysis service will help you gain insight into
            competitors' strategies, market positioning, product features, and
            market performance.
          </p>
        </div>
      </div>
    </div>
    <div class="business-box">
      <div class="content">
        <div class="b-title">A professional online advertising design team that emphasizes the combination of creativity and execution, with outstanding communication and collaboration abilities.</div>
        <div class="list">
          <img src="../assets/bussiness-item-1.png" alt="" />
          <img src="../assets/bussiness-item-2.png" alt="" />
          <img src="../assets/bussiness-item-3.png" alt="" />
          <img src="../assets/bussiness-item-4.png" alt="" />
          <img src="../assets/bussiness-item-5.png" alt="" />
          <img src="../assets/bussiness-item-6.png" alt="" />
        </div>
      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.banner-box {
  background-image: url(../assets/swiper-1.png);
  height: 800px;
  background-size: 100% 100%;
  margin-top: -82px;
  .banner-text {
    margin: 0 360px;
    padding-top: 300px;
    text-align: left;
    .title {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 64px;
      color: #ffffff;
      width: 700px;
    }

    .text {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 22px;
      color: #ffffff;
      margin-top: 20px;
      width: 500px;
    }
  }
}
.banner-list {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 360px;
  padding-top: 150px;
  padding-bottom: 90px;
  .img-list {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 1250px;
    flex-wrap: wrap;
    .item:nth-child(2) {
      margin-top: 50px;
    }
    .item:nth-child(4) {
      margin-top: 50px;
    }
    .item {
      img {
        width: 255px;
        height: 255px;
      }
      p {
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 26px;
        color: #ffffff;
        margin-top: -60px;
        text-align: center;
      }
    }
  }
  .content {
    width: 1200px;
    margin-left: 60px;
    .title {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 45px;
      color: #333333;
      line-height: 60px;
      margin-bottom: 30px;
    }
    .text {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 20px;
      color: rgba(51, 51, 51, 0.8);
    }
  }
}
.wealth-box {
  padding: 0 360px;
  height: 500px;
  background: #f6f6f6;
  .wealth-title {
    float: left;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 52px;
    color: #333333;
    width: 606px;
    margin-top: 70px;
    margin-bottom: 80px;
  }
  .wealth-text {
    float: right;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 20px;
    color: rgba(51, 51, 51, 0.8);
    width: 510px;
    margin-top: 80px;
  }
  .list {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 80px;
    width: 100%;
    .item {
      width: 388px;
      height: 289px;
      background: #ffffff;
      border-radius: 20px 20px 20px 20px;
      img {
        width: 390px;
        height: 312px;
      }
      p {
        margin: 10px 40px;
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 28px;
        color: #ffffff;
        text-align: center;
        margin-top: -76px;
      }
    }
  }
}
.mission-box {
  padding: 150px 360px;
  margin-top: 80px;
  .title {
    text-align: left;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 46px;
    color: #333333;
    width: 800px;
  }
  .list {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 50px;
    .item {
      width: 380px;
      height: 330px;
      text-align: center;
      background: #f6f6f6;
      border-radius: 10px 10px 10px 10px;
      img {
        width: 80px;
        height: 80px;
        margin-top: 31px;
      }
      h4 {
        margin-top: 20px;
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 24px;
        color: #333333;
      }
      p {
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 17px;
        color: #999999;
        margin: 0 40px;
        margin-top: 14px;
      }
    }
  }
}

.business-box {
  height: 1100px;
  .content {
    height: 650px;
    background-size: 100% 100%;
    background: url(../assets/bussiness.png) 100% no-repeat;
    padding: 0 360px;
    background-size: 100% 100%;
    padding-top: 80px;
    overflow: initial;
  }
  .b-title {
    font-family: Cabin, Cabin;
    font-weight: bold;
    font-size: 32px;
    color: #ffffff;
    width: 1000px;
    margin-bottom: 50px;
  }
  .list {
    background: #fafafa;
    border-radius: 10px 10px 10px 10px;
    height: 710px;
    padding: 25px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    img {
      width: 366px;
      height: 344px;
    }
  }
}

.partner-box {
  padding: 100px 360px;
  text-align: center;

  .p-title {
    font-size: 48px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .p-subtitle {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 24px;
  }

  .partner-list {
    display: flex;
    justify-content: space-between;
    margin-top: 70px;
    .item {
      width: 300px;
      padding: 40px;
      height: 610px;
      box-shadow: 0px 32px 24px -20px rgba(223, 223, 223, 0.5);
      border-radius: 8px;
      border: 1px solid rgba(212, 240, 255, 1);
      img {
        width: 80px;
        height: 80px;
      }
      .tit {
        font-size: 24px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        margin: 24px 0;
      }
      .msg {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }
  }
}
</style>
